<template>
  <CloudPrintDetails class="class" @click="$router.push({ name: 'Roadblocks' })">
    <template #header>
      <v-btn icon @click="$router.push({ name: 'Roadblocks' })">
        <v-icon>
          keyboard_arrow_left
        </v-icon>
      </v-btn>
      <div style="display: flex;">
        <TText
          style="margin-left: 5px"
          value="Roadblock Details: "
          font_weight="300"
          medium
        />
        <TText
          style="margin-left: 5px"
          :text="workpackage.name"
          font_weight="300"
          medium
        />
        <TText
          style="margin-left: 5px"
          value="in taktarea: "
          font_weight="300"
          medium
        />
        <TText
          style="margin-left: 5px"
          :text="getUObjectParent({ parent_type: 'taktareas', type: 'twaggons', id: getUObjectParent({ parent_type: 'twaggons', type: 'tworkpackages', id: workpackage.id}).id}).name"
          font_weight="300"
          medium
        />
      </div>
    </template>
    <template #body>
      <h2>Details</h2>
      <div
        v-for="(log, index) in logentries.reverse()"
        :key="`logentries${log.id}`"
        style="width: 100%"
      >
        <ClickableListItem
          :has_lines="true"
          :full_line="true"
          :is_first="index === 0"
          :is_unclickable="true"
          :margin="6"
          background_color="#1E1E1E"
          :foreground_color="'#FFFFFF'"
        >
        <!-- @emittedClick="test()" -->
          <template #front>
            <TTooltip value="Copy to clipboard">
              <TIcon :color="'#FFFFFF'" style="cursor: pointer;" :name="getIconByAction(log.action)" @click.native="copyComment(log)" />
            </TTooltip>
          </template>
          <template #descriptor>
            <div class="work-package-loglist-content">
              <TText
                :text="`${log.user} ${log.created.split(' UTC')[0]}`"
                small
                :color="'#FFFFFF'"
                align="left"
              />
              <TText
                :text="getLogText(log)"
                :color="'#FFFFFF'"
                :size="11"
                :font_weight="400"
                align="left"
                :strikethrough="log.crossed_out"
              />
            </div>
          </template>
          <template #info>
            <!-- <button
              v-if="(log.action == 'comment' || log.action == 'created comment') && log.user === getUser.first_name + ' ' + getUser.last_name"
              class="work-package-loglist-strikethrough"
              :style="`background-color: ${log.crossed_out ? `${getTranspHexColor('#FFFFFF', .25)}` : ''};`"
              v-ripple
              @click.prevent.stop="toggleCrossedOut(log)"
            >
              <TIcon name="strike-through-active"/>
            </button> -->
          </template>
        </ClickableListItem>
      </div>
    </template>
  </CloudPrintDetails>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import CloudPrintDetails from '@/components/CloudPrint/CloudPrintDetails.component.vue'
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import TText from '@/components/Taktify/TText.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue'

export default {
  props: [],
  components: {
    CloudPrintDetails,
    ClickableListItem,
    TText,
    TIcon,
  },
  data: () => ({
    loading: false,
  }),
  created() {
    this.loadData();
  },
  watch: {
      workpackage_id() {
        this.loadData();
      },
    },
  computed: {
    workpackage(){
      return this.getUObject({type: 'tworkpackages', id: this.$route.params.twp_id});
    },
    workpackage_id(){
      return this.$route.params.twp_id;
    },
    logentries(){
      return this.getUObjects({ type: 'logentries', ids: this.workpackage.logentries });
    },
    ...mapGetters('Project', [
      'getFullStatusArray',
      'getStatisticsTrainSelector',
      'hasProjectPermission',
    ]),
    ...mapGetters('TWorkPackage', [
      'getTWorkpackageIcons',
      'getTWorkpackageColors',
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjectParent',
      'getUObjects',
    ]),
  },
  methods: {
    ...mapActions('Ultra', [
      'deleteUObject',
      'requestUObject',
      'updateUObject',
    ]),
    copyToClipboard() {
      var copyText = document.getElementById("cloudprint-link");
      copyText.select();
      document.execCommand("copy");
    },
    loadData() {
      this.loading = true;
      // this.$store.dispatch('WorkPackageLogList/requestWorkPackageLogList', {
      //   project_id: this.$route.params.project_id,
      //   train_id: 0,
      //   taktarea_id: 0,
      //   twaggon_id: 0,
      //   wbgroup_id: 0,
      //   wbline_id: 0,
      //   workpackage_id: this.workpackage_id,
      //   backlog: this.backlog,
      // })
      this.requestUObject({
        url: [
          { projects: this.$route.params.project_id },
          { trains: 0 },
          { taktareas: 0 },
          { twaggons: 0 },
          { tworkpackages: this.workpackage_id },
          { logentries: '' },
          { showWithEntitiesNormalized: '' },
        ],
        add_u_object: true,
      })
      .then(() => {
        this.loading = false;
      });
    },
    getIconByAction(action) {
        switch (action) {
          case 'created':
            return 'sign-plus';
          case 'updated':
            return 'wrench-large';
          case 'comment':
            return 'speech-bubble';
          case 'created comment':
            return 'speech-bubble';
          case 'deleted':
            return 'bin-delete';
          case 'added':
            return 'file-add';
          case 'removed':
            return 'file-remove';
          default:
            return 'exclamation-circle';
        }
      },

      getLogText(log) {
        if(log.action != 'comment' && log.action != 'created comment') {
          // EXAMPLE: Work Package created
          // EXAMPLE: Work Package created: <Name>
          return `${log.target} ${log.action}${log.value ? ': ' + log.value : ''}`;
        }
        else {
          // NOTE: there should never be a comment without a value (without text)
          return `Comment: ${log.value}`;
        }
      },
  }
}
</script>
<style>

</style>
